/**
 * 支付模块常量定义
 */

/**
 * 支付方式枚举
 */
export enum PaymentMethodEnum {
  PAYPAL = 3,
  STRIPE = 4,
}

/**
 * 支付类型（用于埋点）
 */
export enum PaymentType {
  /** 充值 */
  TOPUP = '1',
  /** 订阅 */
  SUBSCRIBE = '2',
}

/**
 * 支付方式名称映射
 */
export const PAYMENT_METHOD_NAMES: Record<number, string> = {
  [PaymentMethodEnum.PAYPAL]: 'paypal',
  [PaymentMethodEnum.STRIPE]: 'stripe',
}

/**
 * 支付方式对应的 payType
 * 用于创建订单时的参数
 */
export const PAYMENT_METHOD_PAY_TYPES: Record<number, number> = {
  [PaymentMethodEnum.PAYPAL]: 6,
  [PaymentMethodEnum.STRIPE]: 5,
}

/**
 * 充值 API 端点映射
 */
export const TOPUP_API_ENDPOINTS: Record<number, string> = {
  [PaymentMethodEnum.PAYPAL]: '/member/topup/createPaypalPaymentIntent',
  [PaymentMethodEnum.STRIPE]: '/member/topup/createStripePaymentIntent',
}

/**
 * 订阅 API 端点
 */
export const SUBSCRIBE_API_ENDPOINT = '/member/subscribe/createOrder'

/**
 * 商品列表 API 端点
 */
export const PRODUCT_LIST_API = {
  TOPUP: '/member/topup/v2/product/list',
  SUBSCRIBE: '/member/subscribe/v2/product/list',
}

/**
 * 支付场景
 */
export type PaymentScenario = 'store' | 'chapter'

/**
 * 默认折扣标签格式化函数
 */
export function formatDiscountLabel(maxDiscountRate?: number | string): string | null {
  if (maxDiscountRate === undefined || maxDiscountRate === null || Number(maxDiscountRate) <= 0)
    return null
  return `${Math.round(Number(maxDiscountRate))}% discount`
}
